// @owners { team: patients-team }
import { SPACING } from '@alto/design-library-tokens';
import { ActionSheetContext, Body, H3, Icon, LgPadding, LgSpacing, ListItem } from '@alto/design-system';
import { useNavigation } from '@alto/navigation';
import React, { useContext, useEffect } from 'react';
import { ASSISTANT_VIEWED_EVENTS } from '~shared/features/alto-assistant/analytics/constants';
import { type ActionSheetProviderStackCacheKey } from '~shared/features/alto-assistant/constants';
import { useAnalytics } from '~shared/hooks';
import { EVENTS } from '~shared/lib/analytics/src/constants';
import { FAQ_KEYS } from '../../../../index';

export const PastCutoff = () => {
  const { navigate } = useNavigation();
  const { trackEvent } = useAnalytics();
  const { closeActionSheet, saveStack } = useContext(ActionSheetContext);

  useEffect(() => {
    trackEvent({
      event: EVENTS.ASSISTANT_COMPONENT_VIEWED,
      params: { name: ASSISTANT_VIEWED_EVENTS.PAST_CUTOFF_ACTION_SHEET },
    });
  }, [trackEvent]);

  const onPressUseDifferentPharmacy = () => {
    saveStack<ActionSheetProviderStackCacheKey>('assistant');
    closeActionSheet();
    navigate('RouteFaq', { faqKey: FAQ_KEYS.TRANSFER_OUT, returnToPreviousScreen: true });
  };

  return (
    <>
      <LgPadding
        topPadding={SPACING.STATIC.NONE}
        bottomPadding={SPACING.STATIC.NONE}
      >
        <H3>Unable to deliver today</H3>
        <Body>Our cutoff time has passed or we’ve reached our capacity for the day.</Body>
        <LgSpacing />
        <H3>Options to get it sooner</H3>
      </LgPadding>
      <ListItem
        onPress={onPressUseDifferentPharmacy}
        LeftContent={<Icon name="paperairplane" />}
        title="Use a different pharmacy"
        RightContent={<Icon name="chevronright-small" />}
      />
    </>
  );
};
